import { render, staticRenderFns } from "./OwnerInDia.vue?vue&type=template&id=67d2c335&scoped=true&"
import script from "./OwnerInDia.vue?vue&type=script&lang=js&"
export * from "./OwnerInDia.vue?vue&type=script&lang=js&"
import style0 from "./OwnerInDia.vue?vue&type=style&index=0&id=67d2c335&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d2c335",
  null
  
)

export default component.exports